import { useState } from "react";
import FinanceReports from "./FinanceReports";
import OrderReports from "./OrderReports";
import { BarChart2, FileSpreadsheet } from "lucide-react";

export default function Reports() {
  const [activeTab, setActiveTab] = useState("finance");

  return (
    <div className="p-4 lg:p-10 space-y-6 max-w-[1400px]">
      <header className="flex items-end justify-between border-b border-[#E5DCC7] pb-6 clf-rule">
        <div>
          <div className="clf-label mb-2">Laporan</div>
          <h1 className="text-3xl tracking-tight font-medium">Rekap Laporan</h1>
          <p className="text-sm text-stone-500 mt-1">Laporan keuangan dan rekap order selesai.</p>
        </div>
      </header>

      <div className="flex items-center gap-2 border-b border-[#E5DCC7] pb-4">
        <button
          onClick={() => setActiveTab("finance")}
          className={`flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
            activeTab === "finance" 
              ? "border-[#B89968] text-stone-900" 
              : "border-transparent text-stone-500 hover:text-stone-900"
          }`}
        >
          <BarChart2 className="w-4 h-4" /> Laporan Keuangan
        </button>
        <button
          onClick={() => setActiveTab("orders")}
          className={`flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
            activeTab === "orders" 
              ? "border-[#B89968] text-stone-900" 
              : "border-transparent text-stone-500 hover:text-stone-900"
          }`}
        >
          <FileSpreadsheet className="w-4 h-4" /> Laporan Order
        </button>
      </div>

      <div className="mt-6">
        {activeTab === "finance" && <FinanceReports isTabbed />}
        {activeTab === "orders" && <OrderReports isTabbed />}
      </div>
    </div>
  );
}
